import { action, Action, createTypedHooks } from 'easy-peasy';

export interface IPPTCreateTipModel {
    isShow: boolean;
    tip: string;
    show: Action<IPPTCreateTipModel, string>;
    hide: Action<IPPTCreateTipModel>;
}

export const pptCreateTipModel: IPPTCreateTipModel = {
    isShow: false,
    tip: '',
    show: action((state, payload) => {
        state.tip = payload;
        state.isShow = true;
    }),
    hide: action((state) => {
        state.isShow = false;
    }),
};

const typedHooks = createTypedHooks<{
    pptCreateTipModel: IPPTCreateTipModel;
}>();

export const useStoreState = typedHooks.useStoreState;
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
